import React from 'react';
import { Box, CircularProgress, TableCell, TableRow, Typography } from '@mui/material';
import { InboxOutlined, ErrorOutline } from '@mui/icons-material';

type LegacyReconciliationTableStateRowProps = {
  colSpan: number;
  mode: 'loading' | 'empty' | 'error';
  message: string;
  minHeight?: number;
};

const LegacyReconciliationTableStateRow: React.FC<LegacyReconciliationTableStateRowProps> = ({
  colSpan,
  mode,
  message,
  minHeight = 360,
}) => {
  const icon = mode === 'loading'
    ? <CircularProgress size={40} />
    : mode === 'error'
      ? <ErrorOutline sx={{ fontSize: 44, color: 'error.main' }} />
      : <InboxOutlined sx={{ fontSize: 44, color: 'text.secondary' }} />;

  return (
    <TableRow>
      <TableCell
        colSpan={colSpan}
        sx={{
          borderBottom: 'none',
          p: 0,
          '&&': { textAlign: 'center !important' },
        }}
      >
        <Box
          sx={{
            minHeight,
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
            gap: 1.5,
            px: 3,
          }}
        >
          {icon}
          <Typography variant="body1" sx={{ fontWeight: 600, color: '#222B45' }}>
            {message}
          </Typography>
        </Box>
      </TableCell>
    </TableRow>
  );
};

export default React.memo(LegacyReconciliationTableStateRow);

